import classNames from 'classnames';
import type { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  noShadow?: boolean;
  transparent?: boolean;
};

export const Card: FC<CardProps> = ({
  className,
  children,
  noShadow,
  transparent,
  ...restProps
}) => (
  <div
    className={twMerge(
      classNames(
        'rounded-lg',
        !transparent && 'bg-default',
        !noShadow && 'shadow',
      ),
      className,
    )}
    {...restProps}
  >
    {children}
  </div>
);
